import { render, staticRenderFns } from "./CrawlerDataReview.vue?vue&type=template&id=14439e22&scoped=true"
import script from "./CrawlerDataReview.vue?vue&type=script&lang=js"
export * from "./CrawlerDataReview.vue?vue&type=script&lang=js"
import style0 from "./CrawlerDataReview.vue?vue&type=style&index=0&id=14439e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14439e22",
  null
  
)

export default component.exports